import { Close } from '@mui/icons-material';
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from '@mui/material';
import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import useFnColorByStatus from './useColorByStatus';

function HelpModal({
  open,
  setOpen,
  hasCalendar,
}: {
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  hasCalendar: boolean;
}) {
  const { t } = useTranslation(['_common', 'timetable']);
  const getBgColorByStatus = useFnColorByStatus();

  const handleClose = useCallback(() => {
    setOpen(false);
  }, [setOpen]);

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>
        {t('_common:timetable')}
        <IconButton size="small" onClick={handleClose} sx={{ float: 'right' }}>
          <Close fontSize="small" />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Typography sx={{ mb: 2 }}>
          {t(
            'timetable:indicates_the_pre-configured_arm_disarm_and_transition_times_between_the_two_quoted_for_your_alarm_system',
          )}
        </Typography>
        {hasCalendar && (
          <>
            <Item
              color={getBgColorByStatus('A')}
              description={
                <>
                  {t('timetable:in_red_we_have')}
                  <strong>{t('timetable:armed_system')}</strong>
                </>
              }
            />
            <Item
              color={getBgColorByStatus('D')}
              description={
                <>
                  {t('timetable:in_green_we_have')}
                  <strong>{t('timetable:disarmed_system')}</strong>
                </>
              }
            />
            <Item
              color={getBgColorByStatus('T')}
              description={
                <>
                  {t('timetable:in_yellow_we_have')}
                  <strong>{t('timetable:tolerance_for_arming_or_disarming')}</strong>
                </>
              }
            />
          </>
        )}
      </DialogContent>
      <DialogActions>
        <Button variant="contained" onClick={handleClose}>
          {t('_common:close')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

function Item({ color, description }: { color: string; description: React.ReactNode }) {
  return (
    <Box sx={{ py: 1 }}>
      <Box
        sx={{
          bgcolor: color,
          width: 10,
          height: 10,
          borderRadius: '50%',
          display: 'inline-block',
        }}
      />
      <Typography
        variant="body2"
        sx={{
          ml: 1,
          display: 'inline-block',
          color: 'text.secondary',
        }}
      >
        {description}
      </Typography>
    </Box>
  );
}

export default HelpModal;
